export enum AddressId {
  Headquarters = 'Headquarters',
  London = 'London',
  Lisbon = 'Lisbon',
  Warsaw = 'Warsaw',
  Wroclaw = 'Wroclaw',
  Dnipro = 'Dnipro',
  Odessa = 'Odessa',
  Kyiv = 'Kyiv',
}

export type Address = {
  id: AddressId
  title: string
  caption: string
}
